import { RACE_STATUS_LIST, convertTimeToMinutes } from '@amwager/util-ts';
import { DatePipe } from '@angular/common';
import { Inject, Pipe, PipeTransform, inject } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'getRaceStatus',
  standalone: true,
  // pure: false
})
export class GetRaceStatusPipe implements PipeTransform {

  // @Inject(DatePipe) private datePipe!: DatePipe;
  private datePipe = inject(DatePipe);

  transform(raceStatus: number = -1, postTime: string = '', eventName?: string): string {
    if (raceStatus === -1) return '';

    // return postTime;

    switch(RACE_STATUS_LIST[raceStatus]) {
      case 'Open': {
        if (!postTime) return '';

        const post = new Date(postTime+'Z').getTime();
        const now = Date.now();
        const mtp = Math.floor((post - now) / 60000);

        return (
          mtp > 60
            ? this.datePipe.transform(postTime + 'Z',  'shortTime')
            : (mtp < 0 ? 0 : mtp) + ' MTP'
        ) || '';
      }
      case 'Closed': return 'C';
      case 'Post': return 'C';
      case 'Final': return 'F';
      case 'Cancelled': return 'C';
      default: return '';
    }
  }

}
